import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getRouteById } from "../routes";
import { ComingSoonPanel } from "../components/ComingSoonPanel";

interface ComingSoonProps {
  /** Override the inferred title (e.g., for hidden sub-feature stubs inside ported modules). */
  title?: string;
  blurb?: string;
}

/**
 * Route-level coming-soon screen: resolves its copy from the current path and
 * hands it to the router-free {@link ComingSoonPanel}, which owns the visual.
 */
export function ComingSoon({ title, blurb }: ComingSoonProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const routeId = location.pathname.split("/").filter(Boolean)[0] ?? "";
  const route = getRouteById(routeId);

  const heading =
    title ?? (route ? t(`nav.${route.id}`, { defaultValue: route.label }) : undefined);
  const sub = blurb ?? (route?.kind === "coming-soon" ? route.blurb : undefined);

  return <ComingSoonPanel title={heading} blurb={sub} />;
}
